import { useShouldRemoveFileUploadPrefix } from '@modules/common/hooks';
import { getDataPointLabel } from '@modules/common/hooks/useGetBucketLabel/getDataPointLabel';
import { getDataPointId } from '@modules/common/utils';
import { AggregateBucketKey } from 'generated/graphql';
import { useEffect, useState } from 'react';
import { FieldNames } from 'v2/core/entities/fields';
import useExecuteEQL from 'v2/core/repository/edge-server/eql/useExecuteEQL';
import { IsLoading } from 'v2/core/repository/edge-server/types';
import { useGetUser } from 'v2/core/services/user';
import { useSearchAnalysesEqlPropsBy } from '.';
import { sourceChartDataPoint } from '../types';

export function useFetchFeedbackSourceDistribution() {
  const shouldRemoveFileUploadPrefix = useShouldRemoveFileUploadPrefix();
  const [sources, setSources] = useState<sourceChartDataPoint[]>([]);

  const {
    tenant: { id: tenantID },
  } = useGetUser();
  const eqlProps = useSearchAnalysesEqlPropsBy(FieldNames.Source);

  const resp = useExecuteEQL({
    input: {
      tenantID,
      eqlProps,
    },
    options: {
      FetchPolicy: 'cache-and-network',
    },
  });

  useEffect(() => {
    if (!resp?.data) {
      return;
    }

    if (resp?.data?.__typename !== 'GetAggregatesResponse') {
      return;
    }

    const dataPoints = resp.data.data
      .map(({ bucket, value }) => {
        if (bucket == null) {
          return undefined;
        }

        return {
          id: getDataPointId(bucket as AggregateBucketKey),
          label: getDataPointLabel({
            bucket: bucket as AggregateBucketKey,
            shouldRemoveFileUploadPrefix,
          }),
          value,
        };
      })
      .filter((item): item is sourceChartDataPoint => !!item);

    setSources(dataPoints);
  }, [resp.data, shouldRemoveFileUploadPrefix]);

  return {
    sources,
    loading: IsLoading(resp.status) && !resp.data,
    error: resp.error,
    refetch: resp.refetch,
  };
}
